/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import proptypes from 'prop-types';
const { node, bool } = proptypes;
import { Typography } from '@one-thd/sui-atomic-components';

const TileFooter = ({ children = null, isDelivery = false }) => {

  return (
    <div className={`sui-pt-2 sui-min-h-[24px] ${isDelivery ? 'sui-pb-2' : ''}`}>
      <Typography data-testid="card-messaging-bottom" variant="body-base" color="success">
        {children}
      </Typography>
    </div>

  );
};
TileFooter.propTypes = {
  children: node,
  isDelivery: bool
};

export { TileFooter };
